module.exports = __webpack_public_path__ + "img/level_17_elite.9038d6b5.svg";